import VectorSource from 'ol/source/Vector'
import GeoJSON from 'ol/format/GeoJSON'
import { Vector as VectorLayer } from 'ol/layer'
import { Fill, Stroke, Style } from 'ol/style'

/* global axios */
const kulturarvStadsdelar = ({ kommun, type, byggnadsInvIds }) => {
  const typeName = type || `view_kulturarv_omraden_${kommun.toLowerCase()}`
  const source = new VectorSource({
    format: new GeoJSON(),
    projection: 'EPSG:3857',
    loader: function (extent, resolution, projection) {
      var proj = projection.getCode()
      axios.post(`${process.env.MIX_ASSET_URL}/api/ltv/wfs`, {
        typeName,
        srsname: proj,
        outputFormat: 'application/json',
        cql_filter: _.isEmpty(byggnadsInvIds) ? null : `byggnadsid IN (${byggnadsInvIds.join(',')})`
        // bbox: extent.join(',') + ',' + proj
      })
        .then(response => response.data)
        .then(text => {
          source.addFeatures(source.getFormat().readFeatures(text))
        })
    }
    // strategy: bboxStrategy
  })

  const layer = new VectorLayer({
    className: 'kulturarvStadsdelarLayer',
    zIndex: 1,
    source: source,
    minResolution: 12,
    maxResolution: 120,
    style: new Style({
      stroke: new Stroke({
        color: 'rgba(254,146,0,.4)',
        width: 3
      }),
      fill: new Fill({
        color: 'rgba(254,146,0,.3)'
      })
    })
  })

  layer.setSource(source)

  return layer
}

export default kulturarvStadsdelar
